import React from 'react';
import { X } from 'lucide-react';
import './TagChip.css';

export const TAG_COLORS = [
  'red', 'lime', 'lightBlue', 'yellow', 'pink',
  'mint', 'periwinkle', 'gray', 'purple', 'darkGreen',
  'darkBlue', 'darkGray', 'black',
] as const;

export type TagColor = typeof TAG_COLORS[number];

export interface TagChipProps {
  name: string;
  color: TagColor;
  size?: 'sm' | 'md';
  onRemove?: () => void;
}

export const TagChip: React.FC<TagChipProps> = ({
  name,
  color,
  size = 'sm',
  onRemove,
}) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.();
  };

  return (
    <span className={`tag-chip tag-chip-${size} tag-chip-${color}`}>
      <span className="tag-chip-dot" />
      <span className="tag-chip-label">{name}</span>
      {onRemove && (
        <button
          className="tag-chip-remove"
          onClick={handleRemove}
          aria-label={`Remove tag ${name}`}
        >
          <X className="tag-chip-remove-icon" />
        </button>
      )}
    </span>
  );
};
